import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthProvider";
import { Redirect, Route, useLocation } from "react-router-dom";

const AdminRoute = props => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  return (
    <Route {...props}>
      {user.role === "private" && user.adminUser ? (
        props.component ? (
          <props.component />
        ) : (
          props.children
        )
      ) : (
        <Redirect to={{ pathname: "/login", state: { from: location } }} />
      )}
    </Route>
  );
};

export default AdminRoute;
